//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scrolingGallery } from '~/utils/utils';

export default {
  props: {
    totalSum: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        ...scrolingGallery(this, 'profileDonation')
      }
    },

    currentSumLine() {
      const lines = [ 100, 1000, 5000, 10000 ]
      const fullSumDonate = Number(this.totalSum)
      const result = lines.map((line, i) => {
        if(fullSumDonate < line.total) {
          return {
            total: line,
            filled: false,
            complete: false,
            percent: 0
          }
        }
        const nextSum = lines[i + 1] ? lines[i + 1] : 100000
        return {
          total: line,
          filled: fullSumDonate > nextSum,
          complete: fullSumDonate >= line,
          percent: fullSumDonate >= nextSum ? 100 : (fullSumDonate - line) / (nextSum - line) * 100,
        }
      })
      return result
    }
  },
  methods: {
    currentNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ₽'
    }
  }
}
